import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { beltonMOConfig } from "./data";

export default function BeltonMOPage() {
  return <CityPageTemplate config={beltonMOConfig} />;
}